import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import HeaderLogin from '../../components/HeaderLogin';

import { setToken } from '../../services/auth';
import api from '../../services/api';

import whats from '../../assets/images/whats2.svg';
import logo from '../../assets/images/logo3.svg';
import arrow from '../../assets/images/arrowRight.svg';

import './styles.css';

export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    setLoading(true);
    console.log('handleSubmit', window.location.href);
    const form = new FormData();
    
    form.append('email', email);
    form.append('password', password);

    api.post('/auth/login', form)
      .then(res => {
        setToken(res.data.access_token);
        window.location.href="/sales";
        setLoading(false);
      })
      .catch(err => {
        alert(err.response.data.error);
        setLoading(false);
      });

  }

  return (
    <>
      {/* <HeaderLogin /> */}
      <div className="d-flex" id="content-login">
        <div className="box-login">
          <img src={logo} className="logo" alt="Cury" onClick={() => window.location.href='/'} />
          <h3>Dashboard 2.0</h3>
          <Form.Group>
            <Form.Label>E-mail</Form.Label>
            <Form.Control type="email" placeholder="Informe seu e-mail" value={email} onChange={(e) => setEmail(e.target.value)} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Senha</Form.Label>
            <Form.Control type="password" placeholder="Informe sua senha" value={password} onChange={(e) => setPassword(e.target.value)} />
          </Form.Group>
          <button type="button" onClick={() => handleSubmit()} disabled={loading}><p>{loading ? `Carregando...` : `Entrar`}</p><img src={arrow} alt="Icon" /></button>
          <a href="/recovery-password">Esqueci a minha senha</a>
          <a id="link-whats-suporte" href="https://wa.me/5511973507272" target={'_blank'}>
            <div id="whats-suporte">
              <img src={whats} alt="Whatsapp" />
            </div>
            <div id="text-suporte">
              <p>Precisa de ajuda?<br />Fale com nosso <span>suporte online.</span></p>
            </div>
          </a>
        </div>
        <div className="bg-login"></div>
      </div>
    </>
  );
  
}

export default Login;